import React from "react"

// TODO: Clean up the use of this file. It's a left over upgrade shim.

export const IntlProvider: React.FunctionComponent = ({ children }) => (
  <>{children}</>
)
export { useIntl } from "react-intl"
